import React from 'react';
import Badge from '../ui/Badge';
import { ALARM_PRIORITY_COLORS, ALARM_PRIORITY_ICONS } from '../../types/alarm.types';

interface AlarmStatusBadgeProps {
  priority: 'low' | 'medium' | 'high' | 'critical';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

/**
 * AlarmStatusBadge Component
 * 
 * Displays a colored badge for alarm priority levels
 */
const AlarmStatusBadge: React.FC<AlarmStatusBadgeProps> = ({ 
  priority, 
  size = 'md',
  showIcon = true 
}) => {
  const colorClass = ALARM_PRIORITY_COLORS[priority] || ALARM_PRIORITY_COLORS.low;
  const icon = ALARM_PRIORITY_ICONS[priority] || ALARM_PRIORITY_ICONS.low;
  
  // Map size prop to actual pixel sizes
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  return (
    <span 
      className={`
        inline-flex items-center gap-1 
        rounded-full border font-medium
        ${colorClass} 
        ${sizeClasses[size]}
      `}
    >
      {showIcon && <span>{icon}</span>}
      <span className="capitalize">{priority}</span>
    </span>
  );
};

export default AlarmStatusBadge;
